import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import AssetFormPopUpComponent from "./AssetFormPopUpComponent";
import moment from "moment/moment";
import axios from "axios";
import { env } from "../../env";
import LoaderIcon from "../Common/Icon/Loader";

const AssetsComponent = ({isActive, customerId, defaultProductImage, allAssignedAssetList, sendUpdatedRequestFromChild}) => {
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [currentAsset, setCurrentAsset] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [conditionList, setConditionList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            await getStatusListApi(baseUrl, token);
            await getConditionListApi(baseUrl, token);
        };
        fetchData();
    }, []);
    
    const getStatusListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Assets/GetStatusList`,{ headers })
        .then((response) => {
            setStatusList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getConditionListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Assets/GetAssetConditions`,{ headers })
        .then((response) => {
            setConditionList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleModalCloseDataFromChild = (data) => {
        if(data === "updated") {
            sendUpdatedRequestFromChild(data);
        }
        setShowModal(false);
    };
    const handleShowModal = async (e, value) => {
        e.preventDefault();
        setShowModal(true);
        setIsLoader(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`${`/api/Assets/GetAllAssignedAssetsById?_id=${value}`}`,{ headers })
        .then((response) => {
            setIsLoader(false);
            if(response.data.length > 0) {
                const result = conditionList.find(condition => condition.Id === response.data[0].Condition_id);
                if(result) {
                    response.data[0].conditionTitle = result.Title;
                } else {
                    response.data[0].conditionTitle = "";
                }
                setCurrentAsset(response.data[0]);
            }
        }).catch((error) => {
            console.log(error);
            setIsLoader(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    }

    return (
        <div className="relative">
            {/* large */}
            <div className="hidden sm:grid lg:grid-cols-2 xl:grid-cols-3 gap-4 bg-transparent rrounded-none p-2 sm:p-0">
                <NavLink to={(isActive ? `/profiles/create-asset/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed") + " rounded-xl border-gray-normal border border-dashed hidden sm:flex flex-col justify-center items-center min-h-24"}>
                    <div className="flex items-center space-x-2">
                        <img className="w-8 h-8" src="../../assets/icons/profile/plus.svg" alt="plus" />
                        <div className="font-medium capitalize">{ t("request new asset")}</div>
                    </div>
                </NavLink>
                {allAssignedAssetList.length > 0 ?
                    allAssignedAssetList.map((asset, index) => (
                        <div key={`asset${index}`} className="rounded-xl bg-white p-2 cursor-pointer flex justify-between space-x-2 w-full shadow-around" onClick={(e) => handleShowModal(e, asset.Id)} >
                            <div className="relative w-28">
                                <img className="w-14 h-14 sm:w-20 sm:h-20 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                <div className="absolute right-0 bottom-0 bg-white rounded-md p-1 shadow-md">
                                    <img src={`../../assets/icons/profile/${asset.IsApproved ? "approved" : "pending"}.svg`} alt="status" />
                                </div>
                            </div>
                            <div className="flex flex-col justify-evenly w-full">
                                <div className="flex justify-between">
                                    <h1 className="font-semibold text-xs sm:text-base capitalize">{asset.Asset_Descr}</h1>
                                    <img src="../../assets/icons/profile/arrow-right.svg" alt="arrow-right" />
                                </div>
                                <div className="flex justify-between space-x-1 items-center w-max">
                                    <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('asset code')}<span className="font-medium text-black">: {asset.AssetCode}</span></div>
                                    <div className="border h-3 border-light-400"></div>
                                    <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('since')}<span className="font-medium text-black">: {moment(asset.Manufactured_date).format('DD/MM/YYYY')}</span></div>
                                </div>
                                <div className="flex justify-between items-center">
                                    <div className="capitalize text-[10px] sm:text-xs">
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('s.no.')}<span className="font-medium text-black">: {asset.Serial_no}</span></div>
                                    </div>
                                    <div className={((asset.Status_id == 1) ? 'bg-green-normal p-1' : ((asset.Status_id == 2) ? 'bg-red-normal p-1' : ((asset.Status_id == 3) ? 'bg-yellow-normal1 p-1' : "p-0"))) + " capitalize text-white rounded-md text-[10px] sm:text-xs"}>
                                        {(asset.Status_id == 1) ? t('active') : ((asset.Status_id == 2) ? t('inactive') : ((asset.Status_id == 3) ? t('maintanance') : null))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                : null}
            </div>
            {/* mobile */}
            <div className="block sm:hidden bg-white rounded-xl p-2 shadow-around">
                {allAssignedAssetList.length > 0 ?
                    allAssignedAssetList.map((asset, index) => (
                        <div key={`asset${index}`}>
                            <NavLink to={`/profiles/edit-asset/${asset.Id}/${customerId}`} key={`asset${index}`} className="rounded-xl bg-white py-2 cursor-pointer flex justify-between space-x-2 w-full shadow-around">
                                <div className="relative w-20">
                                    <img className="w-14 h-14 sm:w-20 sm:h-20 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                    <div className="absolute right-0 -bottom-1 bg-white rounded-md p-1 shadow-md">
                                        <img src={`../../assets/icons/profile/${asset.IsApproved ? "approved" : "pending"}.svg`} alt="status" />
                                    </div>
                                </div>
                                <div className="flex flex-col justify-evenly w-full">
                                    <div className="flex justify-between">
                                        <h1 className="font-semibold text-xs sm:text-base capitalize">{asset.Asset_Descr}</h1>
                                        <img onClick={(e) => handleShowModal(e, asset.Id)} src="../../assets/icons/profile/arrow-right.svg" alt="arrow-right" />
                                    </div>
                                    <div className="flex justify-between space-x-1 items-center w-max">
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('asset code')}<span className="font-medium text-black">: {asset.AssetCode}</span></div>
                                        <div className="border h-3 border-light-400"></div>
                                        <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('since')}<span className="font-medium text-black">: {moment(asset.Manufactured_date).format('DD/MM/YYYY')}</span></div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="capitalize text-[10px] sm:text-xs">
                                            <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('s.no.')}<span className="font-medium text-black">: {asset.Serial_no}</span></div>
                                        </div>
                                        <div className={((asset.Status_id == 1) ? 'bg-green-normal p-1' : ((asset.Status_id == 2) ? 'bg-red-normal p-1' : ((asset.Status_id == 3) ? 'bg-yellow-normal1 p-1' : "p-0"))) + " capitalize text-white rounded-md text-[10px] sm:text-xs"}>
                                            {(asset.Status_id == 1) ? t('active') : ((asset.Status_id == 2) ? t('inactive') : ((asset.Status_id == 3) ? t('maintanance') : null))}
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                            {(allAssignedAssetList.length !== (index+1)) ? <div className="my-1 border-t border-dashed border-background-normal"></div> : null}
                        </div>
                    ))
                : 
                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                        { t('no records available')}
                    </div>
                }
            </div>
            {showModal
            ? 
                <div className="hidden sm:block fixed z-40 sm:z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh px-4 py-8 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block space-y-1 align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md w-full p-4" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="bg-white space-y-2 sm:space-y-3">
                                <div className="flex justify-between items-center">
                                    <div className="font-semibold sm:text-lg capitalize">{ t('asset details')}</div>
                                    <div className="cursor-pointer" onClick={(e) => setShowModal(!showModal)}>
                                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                    </div>
                                </div>
                            </div>
                            {
                                isLoader ?
                                    <LoaderIcon />
                                :
                                <AssetFormPopUpComponent defaultProductImage={defaultProductImage} sendModalCloseDataFromChild={handleModalCloseDataFromChild} currentAsset={currentAsset} statusList={statusList} conditionList={conditionList}/>
                            }
                        </div>
                    </div>
                </div>
            : null}
            <div className="fixed bottom-2 sm:hidden w-screen left-0 px-4">
                <NavLink to={(isActive ? `/profiles/create-asset/${customerId}` : null)}  className={(isActive ? "cursor-pointer" : "cursor-not-allowed")}>
                    <div className="rounded-lg  p-2 text-white bg-blue-normal font-medium text-center capitalize">
                        + { t("request new asset")}
                    </div>
                </NavLink>
            </div>
        </div>
    )
}

export default AssetsComponent;